// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__2PrbA","img":"style_img__kQAB3","descDiv":"style_descDiv__07GJR","title":"style_title___o7eS","description":"style_description__egnFr"};